/* eslint-disable no-unused-vars */
import { TimeEntryErrorModel } from './timeEntryErrorModel'
import ResultDTO from '@/models/app/resultDTO'
import TimeEntryAPIErrorContext from '@/constants/booking/timeEntries/TimeEntryAPIErrorContext'
import ErrorResponseDTO from '@/models/error/errorResponseDTO'

export class TimeEntryMealBreakEndErrorModel extends TimeEntryErrorModel {
  /** @param {ResultDTO<ErrorResponseDTO>} errorResponse */
  constructor(errorResponse) {
    super(errorResponse, TimeEntryAPIErrorContext.mealBreakEnd)

    /**
     * See {@link https://dev.azure.com/anzukeducation/Staffroom%20NEXT/_wiki/wikis/anzuk%20Dev%20Team/366/Ready2Work-2.0?anchor=post-/api/v1.0/time-entries/meal-break-end Error Code Wiki}
     * @type {string[]}
     */
    this.errorCodesToRefresh = [
      'security_error',
      'auto_clocked_out',
      'booking_in_future',
      'booking_not_found',
      'meal_break_not_started',
      'already_ended_meal_break',
      'already_clocked_out',
    ]

    /**
     * See {@link https://dev.azure.com/anzukeducation/Staffroom%20NEXT/_wiki/wikis/anzuk%20Dev%20Team/366/Ready2Work-2.0?anchor=post-/api/v1.0/time-entries/meal-break-end Error Code Wiki}
     * @type {string[]}
     */
    this.errorCodesToRefreshMealBreakStatus = [
      'reduced_meal_break_reason_not_provided',
    ]
  }

  /** @override */
  shouldTriggerTimeEntryStatusRefresh() {
    return this.errorCodesToRefresh.includes(this.errorCode)
  }

  /**
   * Determins if the meal break status endpoint should be refetched.
   * @returns {boolean}
   */
  shouldReloadMealBreakStatus() {
    return this.errorCodesToRefreshMealBreakStatus.includes(this.errorCode)
  }
}
